import React, { useState, useRef, useEffect, useCallback } from 'react';
import {
  makeStyles,
  Tabs,
  Tab,
  Box,
  Typography
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import {
  getListOrders,
  updateOrder,
  deleteOrder,
  resetChange,
  createOrder,
  updateOrderStatus,
  syncOrderDeviceTypes,
  updateOrderInList,
  uploadOrderImages,
  deleteOrderImage
} from 'src/features/orderSlice';
import { getListSales, getListUsers } from 'src/features/userSlice';
import { getListDeviceType } from 'src/features/deviceTypeSlice';
import { getListDevice, updateDeviceTransfer } from 'src/features/deviceSlice';
import { getListAgencies } from 'src/features/agencySlice';
import {
  showGlobalToast,
  showDialogConfirm,
  closeDialogConfirm
} from 'src/features/uiSlice';
import { messageToastType_const } from 'src/app/constant/config';
import { MESSAGE } from 'src/app/constant/message';
import OrderDialog from './OrderDialog';
import OrdersTable from './OrdersTable';
import ToolbarSection from './ToolbarSection';
import SerialDialog from './SerialDialog';
import GalleryModal from './GalleryModal';
import ConfirmDialogs from './ConfirmDialogs';
import InventoryTable from './InventoryTable';

const FAKE_ORDERS = [];

const STATUS_CONFIG = {
  '-1': { label: 'Đã hủy', color: '#666', bg: '#f5f5f5' },
  0: { label: 'Chưa xử lý', color: '#e67e22', bg: '#fef9e7' },
  1: { label: 'Đang xử lý', color: '#2980b9', bg: '#eaf4fb' },
  2: { label: 'Đang vận chuyển', color: '#8e44ad', bg: '#f5eef8' },
  3: { label: 'Đã giao hàng', color: '#1abc9c', bg: '#e8f8f5' },
  4: { label: 'Hoàn thành', color: '#d32f2f', bg: '#fff1f0' }
};


const PAGE_SIZE = 12;

// ─── Main Component ───────────────────────────────────────────────────────────
const SalesOrdersView = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [mainTab, setMainTab] = useState(0);
  const [tabForm, setTabForm] = useState(0);
  const {
    listOrders,
    total,
    statusUpdate,
    statusDelete,
    statusCreate,
    totalAmountSum,
    totalPaidSum,
    statistic
  } = useSelector(state => state.orderSlice);
  const { isAdmin, isAccountant, isSale, dataLogin } = useSelector(
    state => state.authSlice
  );
  const { listDeviceType } = useSelector(state => state.deviceTypeSlice);
  const { listAgencies } = useSelector(state => state.agencySlice || {});
  const { listUsers } = useSelector(state => state.userSlice || {});
  const { listSales } = useSelector(state => state.userSlice || {});

  const [search, setSearch] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterType, setFilterType] = useState('all');
  const [filterDevice, setFilterDevice] = useState('all');
  const [filterSale, setFilterSale] = useState('all');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [page, setPage] = useState(1);
  const [viewingSerials, setViewingSerials] = useState(null);
  const [selectedGallery, setSelectedGallery] = useState(null);

  // Order Creation State
  const [openAddModal, setOpenAddModal] = useState(false);
  const [form, setForm] = useState({
    account: '',
    account_name: '',
    paymentMethod: 'Tiền mặt',
    type: '',
    simType: '',
    simNetwork: '',
    isNewOrder: '',
    note: '',
    fullName: '',
    phone: '',
    company: '',
    installationType: '',
    extra_fee: 0,
    vat: 8
  });
  const [isEditing, setIsEditing] = useState(false);
  const [editOrderId, setEditOrderId] = useState(null);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [orderForImage, setOrderForImage] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [devices, setDevices] = useState([
    { type: 'VGPS_CAM4G', quantity: 1, unitPrice: 0 }
  ]);
  const [fetchType, setFetchType] = useState('account');
  const [suggestionLoading, setSuggestionLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  // Serial Management State
  const [editingOrder, setEditingOrder] = useState(null);
  const [newSerial, setNewSerial] = useState('');
  const [editingDevices, setEditingDevices] = useState([]);

  // Local state for tracking numbers to avoid excessive API calls
  const [localTrackingUrls, setLocalTrackingUrls] = useState({});
  const [countsByStatus, setCountsByStatus] = useState({});

  // Local state for extra fee (phí ship) inline editing
  const [localExtraFees, setLocalExtraFees] = useState({});

  // Dynamic Sticky Separator State
  const [isScrolled, setIsScrolled] = useState(false);

  // Horizontal Drag State
  const scrollContainerRef = useRef(null);
  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [openCompleteConfirm, setOpenCompleteConfirm] = useState(false);
  const [openCancelConfirm, setOpenCancelConfirm] = useState(false);

  const [deletingImage, setDeletingImage] = useState(null);

  const handleDeleteImage = () => {
    if (!deletingImage) return;
    dispatch(deleteOrderImage({ id: deletingImage.id })).then(res => {
      if (!res.error) {
        const orderId = selectedGallery.orderId;
        const newImages = selectedGallery.images.filter(
          img => img.id !== deletingImage.id
        );
        dispatch(
          updateOrderInList({ id: orderId, data: { order_images: newImages } })
        );
        if (newImages.length === 0) {
          setSelectedGallery(null);
        } else {
          const nextIndex =
            selectedGallery.index >= newImages.length
              ? newImages.length - 1
              : selectedGallery.index;
          setSelectedGallery({
            ...selectedGallery,
            images: newImages,
            index: nextIndex
          });
        }
      }
      setDeletingImage(null);
    });
  };

  const searchTimeout = useRef(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOrder, setMenuOrder] = useState(null);

  const handleMenuOpen = (event, order) => {
    setAnchorEl(event.currentTarget);
    setMenuOrder(order);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuOrder(null);
  };

  const handleDeleteOrder = () => {
    dispatch(showDialogConfirm());
    setAnchorEl(null);
  };

  const handleCancelOrder = () => {
    setOpenCancelConfirm(true);
    setAnchorEl(null);
  };

  const confirmCancel = () => {
    if (!menuOrder) return;
    dispatch(
      updateOrderStatus({
        id: menuOrder.id,
        data: { status: -1, note: 'Hủy đơn hàng' },
        suffix: '/status'
      })
    ).then(() => {
      dispatch(updateOrderInList({ id: menuOrder.id, data: { status: -1 } }));
      setOpenCancelConfirm(false);
      setMenuOrder(null);
    });
  };

  const confirmDelete = () => {
    if (menuOrder) {
      dispatch(deleteOrder({ id: menuOrder.id }));
      setMenuOrder(null);
    }
    dispatch(closeDialogConfirm());
  };

  const onMouseDown = e => {
    setIsDown(true);
    setStartX(e.pageX - scrollContainerRef.current.offsetLeft);
    setScrollLeft(scrollContainerRef.current.scrollLeft);
  };
  const onMouseLeave = () => setIsDown(false);
  const onMouseUp = () => setIsDown(false);
  const onMouseMove = e => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - scrollContainerRef.current.offsetLeft;
    const walk = (x - startX) * 1.5;
    scrollContainerRef.current.scrollLeft = scrollLeft - walk;
    handleScroll();
  };

  const handleScroll = () => {
    if (scrollContainerRef.current) {
      setIsScrolled(scrollContainerRef.current.scrollLeft > 0);
    }
  };

  const getPaymentStyle = method => {
    switch (method) {
      case 'Tiền mặt':
        return { color: '#27ae60', bg: '#eafaf1' };
      case 'Chuyển khoản':
        return { color: '#2980b9', bg: '#eaf4fb' };
      case 'Công nợ':
        return { color: '#e67e22', bg: '#fef9e7' };
      case 'COD':
        return { color: '#8e44ad', bg: '#f5eef8' };
      default:
        return { color: '#666', bg: '#f5f5f5' };
    }
  };

  const formatMoney = amount =>
    new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'VND'
    }).format(amount);
  const formatInputMoney = val =>
    String(val).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const parseInputMoney = val => {
    const num = Number(val.replace(/\D/g, ''));
    return num || 0;
  };

  useEffect(() => {
    if (statistic) {
      setCountsByStatus({
        '-1': statistic.total_cancelled_count || 0,
        0: statistic.total_pending_count || 0,
        1: statistic.total_processing_count || 0,
        2: statistic.total_shipping_count || 0,
        3: statistic.total_delivered_count || 0,
        4: statistic.total_completed_count || 0
      });
    }
  }, [statistic]);

  const fetchListOrders = useCallback(() => {
    if ((fromDate && !toDate) || (!fromDate && toDate)) return;

    dispatch(
      getListOrders({
        page,
        page_size: PAGE_SIZE,
        keywords: search || undefined,
        status: filterStatus !== 'all' ? filterStatus : undefined,
        customer_type:
          filterType !== 'all'
            ? filterType === 'Đại lý'
              ? 'AGENCY'
              : 'END_USER'
            : undefined,
        device_type_id:
          filterDevice !== 'all' ? Number(filterDevice) : undefined,
        sale_id: filterSale !== 'all' ? filterSale : undefined,
        from_date: fromDate || undefined,
        to_date: toDate || undefined
      })
    );
  }, [
    dispatch,
    page,
    search,
    filterStatus,
    filterType,
    filterDevice,
    filterSale,
    fromDate,
    toDate
  ]);

  useEffect(() => {
    fetchListOrders();
  }, [fetchListOrders]);

  useEffect(() => {
    if (statusDelete === 1 || statusCreate === 1) {
      dispatch(getListOrders({ page, page_size: PAGE_SIZE }));
      dispatch(resetChange());
    }
  }, [statusDelete, statusCreate, dispatch, page]);

  useEffect(() => {
    dispatch(getListSales({ page: 1, page_size: 1000, role_id: 2 }));
  }, [dispatch]);

  const handleAddDevice = () => {
    const usedTypes = devices.map(d => d.type);
    const nextType = (listDeviceType || []).find(
      dt => !usedTypes.includes(dt.name)
    );
    if (nextType) {
      setDevices([
        ...devices,
        { type: nextType.name, quantity: 1, unitPrice: 0 }
      ]);
    } else {
      dispatch(
        showGlobalToast({
          message: 'Tất cả loại thiết bị đã được thêm vào đơn!',
          type: messageToastType_const.info
        })
      );
    }
  };
  const handleRemoveDevice = index =>
    setDevices(devices.filter((_, i) => i !== index));
  const handleDeviceChange = (index, field, value) => {
    const newDevices = [...devices];
    if (field === 'type') {
      const duplicateIdx = newDevices.findIndex(
        (d, i) => i !== index && d.type === value
      );
      if (duplicateIdx !== -1) {
        newDevices[duplicateIdx] = {
          ...newDevices[duplicateIdx],
          quantity:
            (newDevices[duplicateIdx].quantity || 1) +
            (newDevices[index].quantity || 1)
        };
        setDevices(newDevices.filter((_, i) => i !== index));
        return;
      }
    }
    newDevices[index][field] = value;
    setDevices(newDevices);
  };

  const handleFetchUserInfo = selectedOption => {
    setSelectedUser(selectedOption);
    if (!selectedOption) {
      setForm(prev => ({
        ...prev,
        id: null,
        fullName: '',
        phone: '',
        company: '',
        account_name: ''
      }));
      return;
    }

    if (tabForm === 0) {
      const agency = selectedOption;
      setForm({
        ...form,
        id: agency.id || agency.agency_id || agency.agencyId,
        account:
          fetchType === 'account'
            ? agency.username || agency.account || agency.name || ''
            : agency.leader?.phone || agency.phone || agency.username || '',
        fullName: agency.name || agency.fullname || '',
        phone: agency.leader?.phone || agency.phone || '',
        company: agency.leader?.address || agency.address || '',
        account_name: agency.username || agency.account || agency.name || ''
      });
    } else {
      const user = selectedOption;
      setForm({
        ...form,
        id: user.id || user.user_id || user.userId,
        account: user.phone || user.username || user.account || '',
        fullName: user.full_name || user.fullname || user.username || '',
        phone: user.phone || '',
        company: user.agency?.name || user.address || '',
        account_name: user.username || user.account || ''
      });
    }
  };

  const handleAutocompleteSearch = keywords => {
    if (searchTimeout.current) clearTimeout(searchTimeout.current);

    if (!keywords || keywords.trim().length < 2) {
      setSuggestionLoading(false);
      return;
    }

    setSuggestionLoading(true);
    searchTimeout.current = setTimeout(() => {
      const searchAction = tabForm === 0 ? getListAgencies : getListUsers;
      dispatch(
        searchAction({ keywords, page: 1, page_size: 1000 })
      ).finally(() => setSuggestionLoading(false));
    }, 500);
  };

  const handleEditOrder = order => {
    setIsEditing(true);
    setEditOrderId(order.id);
    const isAgency = order.customer_type === 'AGENCY';
    setTabForm(isAgency ? 0 : 1);

    const user = isAgency ? order.agency : order.end_user;
    setSelectedUser(user);
    setFetchType(isAgency ? 'account' : 'phone');

    setForm({
      id: isAgency ? order.agency_id : order.end_user_id,
      account: isAgency
        ? user?.username || user?.account || user?.name || ''
        : user?.phone || user?.username || user?.account || '',
      account_name: user?.username || user?.account || user?.name || '',
      fullName: user?.name || user?.fullname || user?.full_name || '',
      phone: user?.leader?.phone || user?.phone || '',
      company: user?.leader?.address || user?.address || '',
      paymentMethod: order.payment_method || 'Tiền mặt',
      type:
        order.active_method ||
        (isAgency ? 'VGPS kích hoạt' : 'Khách kích hoạt'),
      simType: order.sim_method
        ? order.sim_method.includes('Sim VGPS') || order.sim_method.includes('Sim Vgps')
          ? 'Sim VGPS'
          : order.sim_method
        : isAgency
          ? 'Sim đại lý'
          : 'Sim VGPS',
      simNetwork: order.sim_method?.includes('(')
        ? order.sim_method.match(/\(([^)]+)\)/)?.[1] || ''
        : '',
      isNewOrder: order.buy_method || 'Lắp mới ',
      note: order.description || '',
      installationType: (order.installer || 'Khách lắp đặt').replace(/Vgps/g, 'VGPS'),
      extra_fee: order.extra_fee || 0,
      vat: order.vat || 8
    });

    const initialDevices = (
      order.order_device_types ||
      order.devices ||
      []
    ).map(d => {
      const typeName =
        d.device_type?.name ||
        d.device_type_name ||
        d.type ||
        listDeviceType.find(lt => lt.id === d.device_type_id)?.name ||
        'N/A';
      return {
        type: typeName,
        quantity: d.quantity,
        unitPrice: d.unit_price || d.unitPrice || 0,
        id: d.id
      };
    });
    setDevices(
      initialDevices.length > 0
        ? initialDevices
        : [{ type: 'VGPS_CAM4G', quantity: 1, unitPrice: 0 }]
    );

    setOpenAddModal(true);
  };

  const handleCreateOrder = () => {
    if (!form.account || !form.id) {
      dispatch(
        showGlobalToast({
          message: 'Vui lòng nhập và kiểm tra thông tin khách hàng!',
          type: messageToastType_const.warning
        })
      );
      return;
    }

    if (
      !form.type ||
      !form.simType ||
      !form.installationType ||
      !form.isNewOrder
    ) {
      dispatch(
        showGlobalToast({
          message: 'Vui lòng chọn đầy đủ các thông tin bắt buộc!',
          type: messageToastType_const.warning
        })
      );
      return;
    }

    if (form.simType === 'Sim VGPS' && !form.simNetwork) {
      dispatch(
        showGlobalToast({
          message: 'Vui lòng chọn nhà mạng cho Sim VGPS!',
          type: messageToastType_const.warning
        })
      );
      return;
    }

    const vatRate = Number(form.vat) || 0;
    const device_amount =
      devices.reduce((acc, d) => acc + d.quantity * (d.unitPrice || 0), 0) *
      (1 + vatRate / 100);
    const extra_fee = Number(form.extra_fee) || 0;
    const total_amount = device_amount + extra_fee;

    const orderData = {
      description: form.note || `Đơn cho: ${form.fullName || form.account}`,
      tracking_number: '',
      shipping_unit: '',
      order_type: 'SALE',
      customer_type: tabForm === 0 ? 'AGENCY' : 'END_USER',
      status: isEditing ? undefined : 0,
      total_amount: total_amount,
      extra_fee: extra_fee,
      paid: isEditing ? undefined : 0,
      vat: vatRate,
      code: '',
      end_user_id: tabForm === 1 ? form.id : null,
      agency_id: tabForm === 0 ? form.id : null,
      parent_id: null,
      payment_method: form.paymentMethod,
      active_method: form.active_method || form.type,
      sim_method:
        form.simType === 'Sim VGPS' && form.simNetwork
          ? `Sim VGPS (${form.simNetwork})`
          : form.simType,
      buy_method: form.isNewOrder,
      installer: form.installationType,
      delivery_method: form.installationType === 'VGPS lắp đặt' ? 0 : 1,
      tracking_number:
        form.installationType === 'VGPS lắp đặt' ? 'offline' : '',
      order_device_types: devices.map(d => ({
        id: d.id,
        device_type_id: listDeviceType.find(lt => lt.name === d.type)?.id || 1,
        quantity: Number(d.quantity),
        unit_price: Number(d.unitPrice) || 0,
        status: 0
      }))
    };

    if (isEditing) {
      dispatch(updateOrder({ id: editOrderId, data: orderData })).then(res => {
        if (res.meta.requestStatus === 'fulfilled') {
          setOpenAddModal(false);
          setIsEditing(false);
          setEditOrderId(null);
          setForm({
            account: '',
            paymentMethod: 'Tiền mặt',
            type: tabForm === 0 ? 'VGPS kích hoạt' : 'Khách kích hoạt',
            simType: '',
            simNetwork: '',
            note: '',
            fullName: '',
            phone: '',
            company: '',
            installationType: 'Khách lắp đặt',
            extra_fee: 0,
            vat: 8
          });
          setDevices([{ type: 'VGPS_CAM4G', quantity: 1, unitPrice: 0 }]);
          fetchListOrders();
        }
      });
    } else {
      dispatch(createOrder(orderData)).then(res => {
        if (res.meta.requestStatus === 'fulfilled') {
          setOpenAddModal(false);
          setForm({
            account: '',
            paymentMethod: 'Tiền mặt',
            type: tabForm === 0 ? 'VGPS kích hoạt' : 'Khách kích hoạt',
            simType: '',
            simNetwork: '',
            note: '',
            fullName: '',
            phone: '',
            company: '',
            installationType: 'Khách lắp đặt',
            extra_fee: 0,
            vat: 8
          });
          setDevices([{ type: 'VGPS_CAM4G', quantity: 1, unitPrice: 0 }]);
        }
      });
    }
  };
  const handleDeliveredToggle = (order, checked) => {
    if (
      checked &&
      order.status < 2 &&
      order.delivery_method !== 0 &&
      order.installer?.replace(/Vgps/g, 'VGPS') !== 'VGPS lắp đặt'
    ) {
      dispatch(
        showGlobalToast({
          message:
            'Vui lòng nhập link vận đơn trước khi xác nhận đã giao hàng!',
          type: messageToastType_const.warning
        })
      );
      return;
    }
    const newStatus = checked ? 3 : 2;
    dispatch(
      updateOrderStatus({
        id: order.id,
        data: {
          status: newStatus,
          note: checked ? 'Đã giao hàng' : 'Đang vận chuyển'
        },
        suffix: '/status'
      })
    ).then(() => {
      dispatch(
        updateOrderInList({ id: order.id, data: { status: newStatus } })
      );
    });
  };

  const handleCompleteOrder = order => {
    setOpenCompleteConfirm(true);
    setAnchorEl(null);
  };

  const confirmComplete = () => {
    if (!menuOrder) return;
    const order = menuOrder;
    Promise.all([
      dispatch(
        updateOrderStatus({
          id: order.id,
          data: { status: 4, note: 'Hoàn thành đơn hàng' },
          suffix: '/status'
        })
      ),
      dispatch(
        updateOrder({
          id: order.id,
          data: { paid: 1 }
        })
      )
    ]).then(() => {
      dispatch(
        updateOrderInList({ id: order.id, data: { status: 4, paid: 1 } })
      );
      dispatch(getListOrders({ page, page_size: PAGE_SIZE }));
      setOpenCompleteConfirm(false);
      setMenuOrder(null);
    });
  };

  const handleSaveExtraFee = order => {
    const raw = localExtraFees[order.id];
    if (raw === undefined) return;
    const newFee = Number(String(raw).replace(/\D/g, '')) || 0;
    const oldFee = order.extra_fee || 0;
    if (newFee === oldFee) return;
    dispatch(updateOrder({ id: order.id, data: { extra_fee: newFee } })).then(
      () => {
        dispatch(
          updateOrderInList({ id: order.id, data: { extra_fee: newFee } })
        );
        fetchListOrders();
      }
    );
  };

  const handleSaveTrackingUrl = order => {
    const url = localTrackingUrls[order.id];
    if (url === undefined || url === (order.tracking_number || '')) return;

    if (url) {
      const newStatus = (order.status || 0) < 2 ? 2 : order.status;
      Promise.all([
        dispatch(
          updateOrderStatus({
            id: order.id,
            data: { status: newStatus, note: 'Đang vận chuyển' },
            suffix: '/status'
          })
        ),
        dispatch(updateOrder({ id: order.id, data: { tracking_number: url } }))
      ]).then(() => {
        dispatch(
          updateOrderInList({
            id: order.id,
            data: { status: newStatus, tracking_number: url }
          })
        );
      });
    } else {
      Promise.all([
        dispatch(
          updateOrderStatus({
            id: order.id,
            data: { status: 1, note: 'Đang xử lý' },
            suffix: '/status'
          })
        ),
        dispatch(updateOrder({ id: order.id, data: { tracking_number: '' } }))
      ]).then(() => {
        dispatch(
          updateOrderInList({
            id: order.id,
            data: { status: 1, tracking_number: '' }
          })
        );
      });
    }
  };

  const totalPages = Math.ceil((total || 0) / PAGE_SIZE);
  const paginated = listOrders || [];

  const handleSearch = e => {
    setSearchInput(e.target.value);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearch(searchInput);
      setPage(1);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchInput]);
  const handleStatusChange = e => {
    setFilterStatus(e.target.value);
    setPage(1);
  };
  const handleTypeChange = e => {
    setFilterType(e.target.value);
    setPage(1);
  };

  return (
    <div className={classes.root}>
      <div className={classes.inner}>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2} style={{ borderBottom: '1px solid #e0e3ef' }}>
          <Tabs
            value={mainTab}
            onChange={(e, v) => setMainTab(v)}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab 
              label="Quản trị bán hàng" 
              style={{ textTransform: 'none', fontWeight: 700, fontSize: 16 }} 
            />
            <Tab 
              label="Quản trị lưu kho" 
              style={{ textTransform: 'none', fontWeight: 700, fontSize: 16 }} 
            />
          </Tabs>
        </Box>

        {mainTab === 0 ? (
          <>
            <Box className={classes.header}>
              <Box className={classes.summaryRow}>
                {Object.entries(STATUS_CONFIG).map(([key, cfg]) => {
                  const isActive = filterStatus === Number(key);
                  return (
                    <Box
                      key={key}
                      onClick={() => {
                        setFilterStatus(isActive ? 'all' : Number(key));
                        setPage(1);
                      }}
                      className={classes.summaryChip}
                      style={{
                        borderColor: cfg.color,
                        background: isActive ? cfg.color : cfg.bg,
                        cursor: 'pointer',
                        transform: isActive ? 'translateY(-2px)' : 'none',
                        boxShadow: isActive ? `0 4px 12px ${cfg.color}44` : 'none',
                        transition: 'all 0.2s'
                      }}
                    >
                      <span
                        className={classes.summaryDot}
                        style={{ background: isActive ? '#fff' : cfg.color }}
                      />
                      <Typography
                        style={{
                          fontSize: 12,
                          color: isActive ? '#fff' : cfg.color,
                          fontWeight: 700
                        }}
                      >
                        {cfg.label}: {countsByStatus[key] || 0}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
            </Box>

            <ToolbarSection
              classes={classes}
              filterStatus={filterStatus}
              setFilterStatus={setFilterStatus}
              setPage={setPage}
              STATUS_CONFIG={STATUS_CONFIG}
              countsByStatus={countsByStatus}
              searchInput={searchInput}
              handleSearch={handleSearch}
              fromDate={fromDate}
              setFromDate={setFromDate}
              toDate={toDate}
              setToDate={setToDate}
              filterType={filterType}
              setFilterType={setFilterType}
              handleTypeChange={handleTypeChange}
              filterDevice={filterDevice}
              setFilterDevice={setFilterDevice}
              filterSale={filterSale}
              setFilterSale={setFilterSale}
              listDeviceType={listDeviceType}
              listSales={listSales}
              search={search}
              setSearch={setSearch}
              setSearchInput={setSearchInput}
              isAdmin={isAdmin}
              isSale={isSale}
              setIsEditing={setIsEditing}
              setEditOrderId={setEditOrderId}
              setForm={setForm}
              setDevices={setDevices}
              setSelectedUser={setSelectedUser}
              setOpenAddModal={setOpenAddModal}
            />
            <OrdersTable
              classes={classes}
              paginated={paginated}
              page={page}
              PAGE_SIZE={PAGE_SIZE}
              STATUS_CONFIG={STATUS_CONFIG}
              isScrolled={isScrolled}
              scrollContainerRef={scrollContainerRef}
              onMouseDown={onMouseDown}
              onMouseLeave={onMouseLeave}
              onMouseUp={onMouseUp}
              onMouseMove={onMouseMove}
              handleScroll={handleScroll}
              isDown={isDown}
              isAdmin={isAdmin}
              isSale={isSale}
              isAccountant={isAccountant}
              listDeviceType={listDeviceType}
              formatMoney={formatMoney}
              formatInputMoney={formatInputMoney}
              getPaymentStyle={getPaymentStyle}
              localExtraFees={localExtraFees}
              setLocalExtraFees={setLocalExtraFees}
              handleSaveExtraFee={handleSaveExtraFee}
              localTrackingUrls={localTrackingUrls}
              setLocalTrackingUrls={setLocalTrackingUrls}
              handleSaveTrackingUrl={handleSaveTrackingUrl}
              handleDeliveredToggle={handleDeliveredToggle}
              setEditingOrder={setEditingOrder}
              setEditingDevices={setEditingDevices}
              setOrderForImage={setOrderForImage}
              setOpenImageModal={setOpenImageModal}
              setSelectedGallery={setSelectedGallery}
              handleMenuOpen={handleMenuOpen}
              handleCompleteOrder={(order) => {
                setMenuOrder(order);
                setOpenCompleteConfirm(true);
              }}
              total={total}
              totalAmountSum={totalAmountSum}
              totalPaidSum={totalPaidSum}
              setPage={setPage}
            />
          </>
        ) : (
          <InventoryTable />
        )}
        <ConfirmDialogs
          classes={classes}
          anchorEl={anchorEl}
          handleMenuClose={handleMenuClose}
          menuOrder={menuOrder}
          isAdmin={isAdmin}
          isSale={isSale}
          isAccountant={isAccountant}
          handleEditOrder={handleEditOrder}
          handleDeleteOrder={handleDeleteOrder}
          handleCancelOrder={handleCancelOrder}
          confirmDelete={confirmDelete}
          openCompleteConfirm={openCompleteConfirm}
          setOpenCompleteConfirm={setOpenCompleteConfirm}
          confirmComplete={confirmComplete}
          openCancelConfirm={openCancelConfirm}
          setOpenCancelConfirm={setOpenCancelConfirm}
          confirmCancel={confirmCancel}
        />

        {/* ── Dialog Thêm Đơn Hàng  ── */}
        <OrderDialog
          open={openAddModal}
          onClose={() => setOpenAddModal(false)}
          isEditing={isEditing}
          editOrderId={editOrderId}
          form={form}
          setForm={setForm}
          devices={devices}
          setDevices={setDevices}
          tabForm={tabForm}
          setTabForm={setTabForm}
          fetchType={fetchType}
          setFetchType={setFetchType}
          suggestionLoading={suggestionLoading}
          setSuggestionLoading={setSuggestionLoading}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          setSelectedImages={setSelectedImages}
          handleCreateOrder={handleCreateOrder}
          handleFetchUserInfo={handleFetchUserInfo}
          handleAutocompleteSearch={handleAutocompleteSearch}
          handleAddDevice={handleAddDevice}
          handleRemoveDevice={handleRemoveDevice}
          handleDeviceChange={handleDeviceChange}
          listDeviceType={listDeviceType}
          listAgencies={listAgencies}
          listUsers={listUsers}
          formatMoney={formatMoney}
          formatInputMoney={formatInputMoney}
          parseInputMoney={parseInputMoney}
        />

        {/* ── Dialog Serial (Scan & Edit) ── */}
        <SerialDialog
          editingOrder={editingOrder}
          setEditingOrder={setEditingOrder}
          newSerial={newSerial}
          setNewSerial={setNewSerial}
          editingDevices={editingDevices}
          setEditingDevices={setEditingDevices}
          isSale={isSale}
          dispatch={dispatch}
          fetchListOrders={fetchListOrders}
        />

        <GalleryModal
          classes={classes}
          openImageModal={openImageModal}
          setOpenImageModal={setOpenImageModal}
          orderForImage={orderForImage}
          setOrderForImage={setOrderForImage}
          selectedImages={selectedImages}
          setSelectedImages={setSelectedImages}
          selectedGallery={selectedGallery}
          setSelectedGallery={setSelectedGallery}
          deletingImage={deletingImage}
          setDeletingImage={setDeletingImage}
          handleDeleteImage={handleDeleteImage}
          uploadOrderImages={uploadOrderImages}
          updateOrderInList={updateOrderInList}
          getListOrders={getListOrders}
          PAGE_SIZE={PAGE_SIZE}
          page={page}
          dispatch={dispatch}
        />
      </div>
      {/* ── Dialog Cập nhật Nợ ── */}
    </div>
  );
};

// ─── Styles ───────────────────────────────────────────────────────────────────
const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    width: '100%',
    paddingBottom: 4
  },
  inner: {
    width: '97%',
    margin: '0 auto',
    paddingTop: 20,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 'calc(100vh - 76px)'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    gap: 12,
    marginBottom: 16
  },
  pageTitle: {
    fontSize: 22,
    fontWeight: 700,
    color: '#1a1f36',
    lineHeight: 1.2
  },
  pageSubtitle: {
    fontSize: 13,
    color: '#888',
    marginTop: 2
  },
  summaryRow: {
    display: 'flex',
    gap: 8,
    flexWrap: 'wrap'
  },
  summaryChip: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '4px 12px',
    borderRadius: 20,
    border: '1px solid'
  },
  summaryDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    flexShrink: 0
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 12,
    padding: '12px 16px',
    marginBottom: 12,
    boxShadow: 'none',
    border: '1px solid #e0e3ef'
  },
  searchInput: {
    flex: '1 1 220px',
    minWidth: 200,
    maxWidth: 340,
    '& .MuiOutlinedInput-root': {
      borderRadius: 8
    }
  },
  filterSelect: {
    minWidth: 150,
    '& .MuiOutlinedInput-root': {
      borderRadius: 8
    },
    '& .MuiInputLabel-root': {
      fontSize: 13
    },
    '& .MuiOutlinedInput-input': {
      fontSize: 13,
      padding: '10.5px 14px'
    }
  },
  tableCard: {
    boxShadow: 'none',
    border: '1px solid #e0e3ef',
    borderRadius: 8,
    overflow: 'hidden',
    '& ::-webkit-scrollbar': {
      height: '6px'
    },
    '& ::-webkit-scrollbar-track': {
      background: '#f1f1f1'
    },
    '& ::-webkit-scrollbar-thumb': {
      background: '#ccc',
      borderRadius: '3px'
    },
    '& ::-webkit-scrollbar-thumb:hover': {
      background: '#3f51b5'
    }
  },
  tableRow: {
    '&:hover': {
      backgroundColor: '#f9faff !important'
    }
  },
  customerName: {
    fontSize: 13,
    fontWeight: 600,
    color: '#1a1f36',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    lineHeight: '1.4em',
    wordBreak: 'break-word'
  },
  typeChip: {
    fontWeight: 600,
    fontSize: 11,
    height: 22,
    borderRadius: 4
  },
  trackingLink: {
    fontSize: 12,
    color: '#3f51b5',
    textDecoration: 'underline',
    cursor: 'pointer',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  statusBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '3px 10px',
    borderRadius: 12,
    fontSize: 12,
    fontWeight: 600,
    whiteSpace: 'nowrap'
  },
  statusDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    flexShrink: 0
  },
  paginationRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 12,
    paddingRight: 4,
    flexWrap: 'wrap',
    gap: 8
  },
  stickyCol: {
    position: 'sticky',
    left: 0,
    backgroundColor: 'white !important',
    zIndex: 10
  },
  stickyHeader: {
    position: 'sticky',
    left: 0,
    zIndex: 11,
    backgroundColor: '#f5f6fa !important'
  }
}));

export default SalesOrdersView;
